/* unplugin-vue-components disabled */import { render } from "./tgx.vue?vue&type=template&id=3815af0c&scoped=true"
import script from "./tgx.vue?vue&type=script&lang=js"
export * from "./tgx.vue?vue&type=script&lang=js"

import "./tgx.vue?vue&type=style&index=0&id=3815af0c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3815af0c"]])

export default __exports__